import { render } from "./GameAdd.vue?vue&type=template&id=ea884fe6&scoped=true"
import script from "./GameAdd.vue?vue&type=script&lang=js"
export * from "./GameAdd.vue?vue&type=script&lang=js"

import "./GameAdd.vue?vue&type=style&index=0&id=ea884fe6&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-ea884fe6"

export default script